export const PRESET_TYPE_PC = 'pc';
export const PRESET_TYPE_MOBILE = 'mobile';

export const PRESET_PC = {
  name: 'pc',
  type: PRESET_TYPE_PC,
  label: 'PC',
  width: 0,
  height: 0
};

export const PRESET_MOBILE_1 = {
  name: 'mobile1',
  type: PRESET_TYPE_MOBILE,
  label: '갤럭시S5',
  width: 360,
  height: 640
};

export const PRESET_MOBILE_2 = {
  name: 'mobile2',
  type: PRESET_TYPE_MOBILE,
  label: 'Pixel 2',
  width: 411,
  height: 731
};

export const PRESET_MOBILE_3 = {
  name: 'mobile3',
  type: PRESET_TYPE_MOBILE,
  label: '아이폰 6/7/8',
  width: 375,
  height: 667
};

export const PRESET_MOBILE_4 = {
  name: 'mobile4',
  type: PRESET_TYPE_MOBILE,
  label: '아이폰 6/7/8 plus',
  width: 414,
  height: 736
};

export const PRESET_MOBILE_5 = {
  name: 'mobile5',
  type: PRESET_TYPE_MOBILE,
  label: '아이폰 X',
  width: 375,
  height: 812
};

export const PreviewMobilePresets = [
  PRESET_MOBILE_1,
  PRESET_MOBILE_2,
  PRESET_MOBILE_3,
  PRESET_MOBILE_4,
  PRESET_MOBILE_5
];
